import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

/**
 * CourseDetails component
 * @param {Object} props
 * @param {string} props.imageSrc - The source URL for the course image
 * @param {number} props.progressPercentage - The progress percentage to display
 * @param {string} props.title - The title of the course
 * @param {string} props.badgeStatus - The badge status (e.g. "Completed" or "Get Started")
 * @param {string} props.badgeBtn - The badge status (e.g. "Completed" or "Get Started")
 */
export default function CourseDetails({
  id,
  imageSrc,
  progressPercentage,
  title,
  badgeStatus,
  badgeBtn,
  onStartCourse,
}) {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false); // loading state

  // const handleNavigate = () => {
  //   setLoading(true);
  //   navigate(`/courses-view/${id}`, { state: { loading: true } }); // Pass the loading state during navigation
  // };

  const handleNavigate = () => {
    setLoading(true);

    // If course was "Not Started", update UI state (no API call)
    if (badgeStatus === "Not Started" && onStartCourse) {
      onStartCourse(id); // Updates parent component's state only
    }

    // Navigate directly to the course modules
    navigate(`/courses/${id}/modules`);
  };

  return (
    <div className="course-details">
      <div className="course-image-container" onClick={handleNavigate}>
        <img alt="course-image" className="course-image" src={imageSrc} />
        <div className="courses-progress-bar">
          <div
            className="courses-progress"
            style={{ width: `${progressPercentage}%` }}
          ></div>
        </div>
        <div className="progress-details flex justify-center items-center">
          <h1 className="text-body-b1 mb-0">
            {`${
              Number.isInteger(progressPercentage)
                ? progressPercentage
                : progressPercentage.toFixed()
            }%`}
          </h1>
        </div>
      </div>
      <div className="course-details-text">
        <h3
          className="text-body-b2 mb-0 mt-3"
          style={{
            color: "#ffffff",
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
            textOverflow: "ellipsis",
            lineHeight: "1.2",
            height: "2.4em",
            minHeight: "2.4em",
          }}
        >
          {title}
        </h3>
        <div className="d-flex gap-2 justify-content-center w-100">
          <button
            className={`btn-1 btn-1-basic text-body-b3 ${badgeBtn}`}
            style={{ height: "32px", flexGrow: 1, padding: "4px 22px" }}
          >
            {badgeStatus}
          </button>
          <button
            className="btn-1 btn-1-primary text-body-b3"
            style={{
              height: "32px",
              flexGrow: 1,
              background: "var(--Primary-300, #66baff)",
              color: "var(--Bg-Dark, #0a1722)",
              padding: "4px 22px",
              whiteSpace: "nowrap",
            }}
            // onClick={() => (window.location.href = "/courses-view")}
            onClick={handleNavigate}
          >
            {badgeStatus === "Not Started"
              ? "Get Started"
              : badgeStatus === "In Progress"
                ? "Continue"
                : "Review Course"}
          </button>
        </div>
      </div>
    </div>
  );
}
